document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('a.Page_quick_link[href^="#"]').forEach(anchor => {
        anchor.addEventListener('click', function(e) {
            e.preventDefault();
            
            const targetId = this.getAttribute('href').substring(1);
            const targetElement = document.getElementById(targetId);
            
            if (targetElement) {
            targetElement.scrollIntoView({ behavior: 'smooth' });
            }
        });
    });
});